define((require) => {
    "use strict";

    const AbstractProjectAttachView = require("ui/projects/AbstractProjectAttachView");
    const Promise                   = require("shared/util/Promise");
    const ProjectAttachImageView    = require("ui/projects/image/ProjectAttachImageView");
    const ImageCollection           = require("data/ImageCollection");
    const AbstractImageLibraryView  = require("ui/imageLibrary/AbstractImageLibraryView");

    const CollectionView = AbstractImageLibraryView.extend({

        itemView: ProjectAttachImageView,

        options: {
            showDropTarget: false
        }

    });

    return AbstractProjectAttachView.extend("ProjectAttachImageLibraryView", {

        className: AbstractProjectAttachView.prototype.className + " images",

        collectionView: CollectionView,

        collectionOptions() {
            const imageCollection = new ImageCollection();
            const imageLibrarySorting = this.options.imageLibrarySorting;

            return Promise.all([ImageCollection.count(), imageCollection.query(imageLibrarySorting.getSelectedSorting().query)])
                .then((results) => {
                    return {
                        header: {
                            label: "All Images",
                            count: results[0]
                        },
                        collection: imageCollection,
                        imageLibrarySorting
                    };
                });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/image/ProjectAttachImageLibraryView.js